import * as styles from "./AutocompleteEmpty.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";

import type { AutocompleteEmptyProps } from "./Autocomplete.types";

export function AutocompleteEmpty({
  className,
  ...props
}: AutocompleteEmptyProps): JSX.Element {
  return (
    <BaseAutocomplete.Empty
      data-slot="autocomplete-empty"
      className={clsx(styles.empty, className)}
      {...props}
    />
  );
}
